import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { AssessmentContext } from "../../contexts/assessments";
import { Typography } from "@mui/material";
import BlocksAdmin from "../../components/BlocksAdmin";
import UsersAssessment from "../../components/UsersAssessment";
import CompaniesTIM from "../../components/CompaniesTIM";
import Companies360 from "../../components/Companies360";
import SelfGroups from "../../components/SelfGroups";
import { getAllAssessment, getCompaniesByCategory } from "../../axios/axiosFunctions";

const slugToCategoryMap = {
    tim_self_assessment: "tim",
    executive_team_assessment: "executive",
    lim_360_assessment: "lim360",
    mim_360_assessment: "mim360",
    simple_360_feedback: "simple360",
};

const slugToSelfGroupCategory = {
    lim_self_assessment: "lim_self",
    mim_self_assessment: "mim_self",
};

const AssessmentAdmin = () => {

    const {slugAssessment} = useParams();
    const {isLoading,getAssessmentBySlug} = useContext(AssessmentContext)
    const [rows, setRows] = useState([{id:1}]);
    const [currentAssessment, setCurrentAssessment] = useState();
    const [allCompanies, setAllCompanies] = useState([]);
    const [loadingCompanies, setLoadingCompanies] = useState(true);

    const category = slugToCategoryMap[slugAssessment];

    useEffect(() => {
        if(!isLoading){
            if(category){
                callCompanies();
            }
            const assessment = getAssessmentBySlug(slugAssessment);
            setCurrentAssessment(assessment);
            // The logged-in assessments list filters out 360s the user doesn't
            // own, so fetch this one directly for the question editor.
            if (!assessment && slugAssessment === "simple_360_feedback") {
                getAllAssessment().then((all) => {
                    const found = (all || []).find((a) => a.slug === slugAssessment);
                    if (found) setCurrentAssessment(found);
                });
            }
        }
    }, [isLoading,slugAssessment]);

    useEffect(() => {
        if(currentAssessment){
            const tempRows = currentAssessment?.users.map((u)=>({
                id: u._id,
                firstName: u.firstName,
                lastName: u.lastName,
                email: u.email,
            }));
            setRows(tempRows);
        }
    }, [currentAssessment]);

    const callCompanies = async()=>{
        const companies = await getCompaniesByCategory(category);
        setAllCompanies(companies);
        setLoadingCompanies(false);
    }

    return (
    <>
        <Typography component={"div"} variant="h3" fontWeight={500} color="secondary" dangerouslySetInnerHTML={{ __html: currentAssessment?.name }}/>
        {
            (slugAssessment === "mim_self_assessment" || slugAssessment === "lim_self_assessment") &&
            <>
                <BlocksAdmin assessment={currentAssessment} blocks={currentAssessment?.blocks}/>
                <SelfGroups
                    category={slugToSelfGroupCategory[slugAssessment]}
                    assessmentId={currentAssessment?._id}
                />
                <UsersAssessment rows={rows} assessmentId={currentAssessment?._id}/>
            </>
        }
        {
            slugAssessment === "tim_self_assessment" && <>
                <BlocksAdmin assessment={currentAssessment} blocks={currentAssessment?.blocks}/>
                <CompaniesTIM companies={allCompanies} callCompanies={callCompanies} loading={loadingCompanies} category={"tim"}/>
            </>
        }
        {
            slugAssessment === "executive_team_assessment" && <>
                <BlocksAdmin assessment={currentAssessment} blocks={currentAssessment?.blocks}/>
                <CompaniesTIM companies={allCompanies} callCompanies={callCompanies} loading={loadingCompanies} category={"executive"}/>
            </>
        }
        {
            slugAssessment === "lim_360_assessment" && <Companies360 companies={allCompanies} callCompanies={callCompanies} loading={loadingCompanies} category={"lim360"}/>
        }
        {
            slugAssessment === "mim_360_assessment" && <Companies360 companies={allCompanies} callCompanies={callCompanies} loading={loadingCompanies} category={"mim360"}/>
        }
        {
            slugAssessment === "simple_360_feedback" && <>
                <Typography variant="body2" color="secondary" sx={{marginTop:"8px"}}>
                    Question text uses the placeholder <strong>[feedback receiver]</strong>, which is replaced with the feedback receiver's name when providers take the survey. Keep it in place when editing questions.
                </Typography>
                <BlocksAdmin assessment={currentAssessment} blocks={currentAssessment?.blocks}/>
                <Companies360 companies={allCompanies} callCompanies={callCompanies} loading={loadingCompanies} category={"simple360"}/>
            </>
        }
    </>
    )
}

export default AssessmentAdmin